import React, { useState, useContext } from 'react';
import './ToggleButton.css';
import { useDispatch } from 'react-redux';
import { addLeftRightButton } from '../../Redux/CommonReducer';
import LanguageContext from '../../Utiliz/LanguageContext';
import LoadingContext from '../../Utiliz/LoadingContext';
const ToggleButton = () => {
  const { language } = useContext(LanguageContext);
  const [isLeft, setIsLeft] = useState("Righthand");
  const { loading } = useContext(LoadingContext);
  const dispatch = useDispatch();
  const handleToggle = (name) => {
    dispatch(addLeftRightButton(name))
    setIsLeft(name);
  };

  return (
    <div className="toggle-button" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
      <button
        className={isLeft === 'Righthand' ? 'active' : 'non-active'}
        onClick={() => handleToggle("Righthand")}
      >
        {language === 'en' ? 'Right Hand' : '오른손'}
      </button>
      <button
        className={isLeft === 'Lefthand' ? 'active' : 'non-active'}
        onClick={() => handleToggle("Lefthand")}
      >
        {language === 'en' ? 'Left Hand' : '왼손'}
      </button>
    </div>
  );
};

export default ToggleButton;